import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ThrowStmt } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  MeetingType,
  ScreeningParty,
  ScreeningPartyType,
} from '../../models/screening-party.model';

@Injectable({
  providedIn: 'root',
})
export class ScreeningPartyService {
  private isUpdate: boolean;
  private screeningParty: ScreeningParty;
  private screeningPartyId: number;

  constructor(private http: HttpClient, private datePipe: DatePipe) {}

  getIsUpdate(): boolean {
    return this.isUpdate;
  }

  setIsUpdate(isUpdate: boolean): void {
    this.isUpdate = isUpdate;
  }

  getScreeningParty(): ScreeningParty {
    return this.screeningParty;
  }

  setScreeningParty(screeningParty: any): void {
    this.screeningParty = screeningParty;
    this.screeningParty.cinejoyFeaturedMovie = +screeningParty.cinejoyFeaturedMovie;
    this.screeningParty.meetingDateTime = this.datePipe.transform(this.screeningParty.meetingDateTime, 'yyyy-MM-ddTHH:mm');
    this.screeningParty.meetingLocalDateTime = this.datePipe.transform(this.screeningParty.meetingLocalDateTime, 'yyyy-MM-ddTHH:mm');
    this.screeningParty.screeningPartyType = screeningParty.partyType === 'SHOWCASE' ? ScreeningPartyType.SHOWCASE : ScreeningPartyType.SPOTLIGHT;
    this.screeningParty.meetingType = screeningParty.meetingType === 'GATHER_TOWN' ? MeetingType.GATHER_TOWN : MeetingType.ZOOM;
  }

  getScreeningPartyId(): number {
    return this.screeningPartyId;
  }

  setScreeningPartyId(screeningPartyId: number): void {
    this.isUpdate = false;
    this.screeningPartyId = screeningPartyId;
  }

  resetScreeningParty(): void {
    this.screeningParty = undefined;
    this.screeningPartyId = undefined;
    this.isUpdate = false;
  }

  getPartiesList(): Observable<any> {
    const url = environment.apiURL + `api/screening-party`;
    return this.http.get(url, { withCredentials: true });
  }

  fetchScreeningParty(screeningPartyId: number): Observable<any> {
    const url = environment.apiURL + `api/screening-party/${screeningPartyId}`;
    return this.http.get(url, { withCredentials: true });
  }

  createScreeningParty(screeningParty: ScreeningParty): Observable<any> {
    const url = environment.apiURL + 'api/screening-party';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(url, screeningParty, { headers });
  }

  updateScreeningParty(
    id: number,
    screeningParty: ScreeningParty
  ): Observable<any> {
    const url = environment.apiURL + `api/screening-party/${id}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(url, screeningParty, { headers });
  }

  exportScreeningPartyInvitation(
    partyId: number,
    isEdit: boolean
  ): Observable<any> {
    const url =
      environment.apiURL +
      `api/screeningparty/${partyId}/invitation/export/${isEdit}`;
    return this.http.get(url);
  }

  postRsvp(id: any): Observable<any> {
    const url = environment.apiURL + `api/screening-party/${id}/register`;
    console.log(url);
    return this.http.post(url, { withCredentials: true });
  }
}
